import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {usStates} from './assets/usStates';
import {countries} from './assets/countries';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        member: {
            fieldSets: [
                {
                    "name": "personal",
                    "displayName": "Personal Information",
                    "required": false,
                    "fields": [
                        {
                            label: 'First Name',
                            name: 'first_name',
                            value: '',
                            required: true,
                            type: 'text'
                        },
                        {
                            label: 'Last Name',
                            name: 'last_name',
                            value: '',
                            required: true,
                            type: 'text'
                        },
                        {
                            label: 'Middle Name',
                            name: 'middle_name',
                            value: '',
                            required: false,
                            type: 'text'
                        },
                        {
                            label: 'Primary Degree',
                            name: 'primary_degree',
                            value: '',
                            required: true,
                            type: 'select',
                            options: [
                                'MD',
                                'DO',
                                'RN',
                                'NP',
                                'ARNP',
                                'MS',
                                'BA',
                                'BS',
                                'PA',
                            ],
                        },
                        {
                            label: 'Sex',
                            name: 'sex',
                            value: '',
                            required: false,
                            type: 'select',
                            options: [
                                {
                                    text: 'Male',
                                    value: 'M'
                                },
                                {
                                    text: 'Female',
                                    value: 'F'
                                },
                                {
                                    text: 'Prefer Not To Say',
                                    value: ''
                                },
                            ]
                        },

                        {
                            label: 'Date of Birth',
                            name: 'dob',
                            value: '',
                            required: true,
                            type: 'date'
                        },
                        {
                            label: 'ME #',
                            name: 'me_number',
                            value: '',
                            required: true,
                            type: 'text'
                        },
                    ]
                },
                {
                    "name": 'contacts',
                    "displayName": 'Contact Information',
                    "required": false,
                    "fields": [
                        {
                            label: 'Contacts',
                            name: 'contacts',
                            value: '',
                            required: true,
                            type: 'group',
                            fields: [
                                {
                                    label: 'Phone Number',
                                    name: 'phone_numbers',
                                    value: '',
                                    required: true,
                                    type: 'group',
                                    fields: [
                                        {
                                            'label': 'Cell',
                                            'name': 'cell_phone',
                                            'required': true,
                                            'fields': [
                                                {
                                                    label: 'Phone Number',
                                                    name: 'phone',
                                                    value: '',
                                                    required: true,
                                                    type: 'text'
                                                },
                                            ]
                                        },
                                        {
                                            'label': 'Work',
                                            'name': 'work_phone',
                                            'fields': [
                                                {
                                                    label: 'Phone Number',
                                                    name: 'phone',
                                                    value: '',
                                                    required: false,
                                                    type: 'text'
                                                },
                                            ]
                                        },
                                        {
                                            'label': 'Home',
                                            'name': 'home_phone',
                                            'fields': [
                                                {
                                                    label: 'Phone Number',
                                                    name: 'phone',
                                                    value: '',
                                                    required: false,
                                                    type: 'text'
                                                },
                                            ]
                                        },

                                    ]
                                },
                                {
                                    label: 'Email Address',
                                    name: 'email_addresses',
                                    value: '',
                                    required: true,
                                    type: 'group',
                                    fields: [
                                        {
                                            'label': 'Personal',
                                            'name': 'personal_email',
                                            'required': true,
                                            'fields': [
                                                {
                                                    label: 'Email',
                                                    name: 'email',
                                                    value: '',
                                                    required: true,
                                                    type: 'email'
                                                },
                                            ]
                                        },
                                        {
                                            'label': 'Work',
                                            'name': 'work_email',
                                            'fields': [
                                                {
                                                    label: 'Email',
                                                    name: 'email',
                                                    value: '',
                                                    required: false,
                                                    type: 'email'
                                                },
                                            ]
                                        },
                                    ]
                                },
                                /*                                {
                                                                    label: 'Fax Number',
                                                                    name: 'fax_numbers',
                                                                    value: '',
                                                                    required: false,
                                                                    type: 'group',
                                                                    fields: [
                                                                        {
                                                                            'label': 'Home',
                                                                            'name': 'home_fax',
                                                                            'fields': [
                                                                                {
                                                                                    label: 'Fax',
                                                                                    name: 'fax',
                                                                                    value: '',
                                                                                    required: false,
                                                                                    type: 'text'
                                                                                },
                                                                            ]
                                                                        },
                                                                        {
                                                                            'label': 'Work',
                                                                            'name': 'work_fax',
                                                                            'fields': [
                                                                                {
                                                                                    label: 'Fax',
                                                                                    name: 'fax',
                                                                                    value: '',
                                                                                    required: false,
                                                                                    type: 'text'
                                                                                },
                                                                            ]
                                                                        }
                                                                    ]
                                                                },*/
                            ]
                        }
                    ]
                },
                {
                    "name": "addresses",
                    "displayName": "Addresses",
                    "required": false,
                    "fields": [

                        {
                            label: 'Address',
                            name: 'addresses',
                            value: '',
                            required: true,
                            type: 'group',
                            fields: [
                                {
                                    'label': '',
                                    'name': 'address_1',
                                    'fields': [
                                        {
                                            label: 'Address Type',
                                            name: 'address_label',
                                            value: '',
                                            required: true,
                                            type: 'select',
                                            options: [
                                                'Home',
                                                'Work',
                                                'Box'
                                            ],
                                        },
                                        {
                                            label: 'Address 1',
                                            name: 'address_1',
                                            value: '',
                                            required: true,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Address 2',
                                            name: 'address_2',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'City',
                                            name: 'city',
                                            value: '',
                                            required: true,
                                            type: 'text'
                                        },
                                        {
                                            label: 'State or Province',
                                            name: 'state',
                                            value: '',
                                            required: true,
                                            type: 'select',
                                            options: usStates
                                        },
                                        {
                                            label: 'Zip',
                                            name: 'zip',
                                            value: '',
                                            required: true,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Country',
                                            name: 'country',
                                            value: '',
                                            required: true,
                                            type: 'select',
                                            options: countries
                                        },
                                    ]
                                },
                                {
                                    'label': '',
                                    'name': 'address_2',
                                    'fields': [
                                        {
                                            label: 'Address Type',
                                            name: 'address_label',
                                            value: '',
                                            required: false,
                                            type: 'select',
                                            options: [
                                                'Home',
                                                'Work',
                                                'Box'
                                            ],
                                        },
                                        {
                                            label: 'Address 1',
                                            name: 'address_1',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Address 2',
                                            name: 'address_2',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'City',
                                            name: 'city',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'State or Province',
                                            name: 'state',
                                            value: '',
                                            required: false,
                                            type: 'select',
                                            options: usStates,
                                        },
                                        {
                                            label: 'Zip',
                                            name: 'zip',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Country',
                                            name: 'country',
                                            value: '',
                                            required: false,
                                            type: 'select',
                                            options: countries
                                        },
                                    ]
                                },
                            ]
                        },

                    ],


                },
                /*                {
                                    "name": "education",
                                    "displayName": "Education",
                                    "required": false,
                                    fields: [
                                        {
                                            label: '',
                                            name: 'degrees',
                                            value: '',
                                            required: true,
                                            type: 'group',
                                            fields: [
                                                {
                                                    'label': 'Undergraduate',
                                                    'name': 'undergraduate',
                                                    'fields': [
                                                        {
                                                            label: 'Institution Name',
                                                            name: 'institution',
                                                            value: '',
                                                            required: false,
                                                            type: 'text'
                                                        },
                                                        {
                                                            label: 'Completion Date',
                                                            name: 'date',
                                                            value: '',
                                                            required: false,
                                                            type: 'date'
                                                        },
                                                        {
                                                            label: 'Degree',
                                                            name: 'degree',
                                                            value: '',
                                                            required: false,
                                                            type: 'text'
                                                        },
                                                    ]
                                                },
                                                {
                                                    'label': 'Medical School',
                                                    'name': 'medical',
                                                    'fields': [
                                                        {
                                                            label: 'Institution Name',
                                                            name: 'institution',
                                                            value: '',
                                                            required: false,
                                                            type: 'text'
                                                        },
                                                        {
                                                            label: 'Date',
                                                            name: 'date',
                                                            value: '',
                                                            required: false,
                                                            type: 'date'
                                                        },
                                                        {
                                                            label: 'Degree',
                                                            name: 'degree',
                                                            value: '',
                                                            required: false,
                                                            type: 'text'
                                                        },
                                                    ]
                                                },
                                                {
                                                    'label': 'Residency',
                                                    'name': 'residency',
                                                    'fields': [
                                                        {
                                                            label: 'Institution Name',
                                                            name: 'institution',
                                                            value: '',
                                                            required: false,
                                                            type: 'text'
                                                        },
                                                        {
                                                            label: 'Completion Date',
                                                            name: 'date',
                                                            value: '',
                                                            required: false,
                                                            type: 'date'
                                                        },
                                                        {
                                                            label: 'ACGME Accredited Program',
                                                            name: 'degree',
                                                            value: '',
                                                            required: false,
                                                            type: 'select',
                                                            options: [
                                                                'General Surgery',
                                                                'Integrated Vascular Surgery',
                                                                'Vascular Surgery Fellowship'
                                                            ],
                                                        },
                                                    ]
                                                },
                                                {
                                                    'label': 'Fellowship',
                                                    'name': 'fellowship',
                                                    'fields': [
                                                        {
                                                            label: 'Institution Name',
                                                            name: 'institution',
                                                            value: '',
                                                            required: false,
                                                            type: 'text'
                                                        },
                                                        {
                                                            label: 'Completion Date',
                                                            name: 'date',
                                                            value: '',
                                                            required: false,
                                                            type: 'date'
                                                        },
                                                    ]
                                                },
                                            ]
                                        },
                                    ]
                                },*/
                {
                    "name": "practices",
                    "displayName": "Practices and Professional Affiliations",
                    "required": false,

                    "fields": [
                        //allow multiple
                        {
                            label: '',
                            name: 'practices',
                            type: "group",
                            value: '',
                            required: false,
                            multiple: true,
                            'fields': [
                                {
                                    'label': '',
                                    'name': 'practices_1',
                                    'fields': [
                                        {
                                            label: 'Practice or Affiliation Name',
                                            name: 'name',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Start Date',
                                            name: 'start_date',
                                            value: '',
                                            required: false,
                                            type: 'date'
                                        },
                                        {
                                            label: 'End Date',
                                            name: 'end_date',
                                            value: '',
                                            required: false,
                                            type: 'date'
                                        },
                                        {
                                            label: 'Narrative of Practice Experiences Since Completion of Training',
                                            name: 'narrative',
                                            value: '',
                                            required: false,
                                            type: 'textarea'
                                        },
                                    ]
                                },
                                {
                                    'label': '',
                                    'name': 'practices_2',
                                    'fields': [
                                        {
                                            label: 'Practice or Affiliation Name',
                                            name: 'name',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Start Date',
                                            name: 'start_date',
                                            value: '',
                                            required: false,
                                            type: 'date'
                                        },
                                        {
                                            label: 'End Date',
                                            name: 'end_date',
                                            value: '',
                                            required: false,
                                            type: 'date'
                                        },
                                        {
                                            label: 'Narrative of Practice Experiences Since Completion of Training',
                                            name: 'narrative',
                                            value: '',
                                            required: false,
                                            type: 'textarea'
                                        },
                                    ]
                                },
                            ]
                        },
                    ]

                },
                {
                    "name": "hospitals",
                    "displayName": "Hospital Affiliations",
                    "required": false,

                    "fields": [
                        //allow multiple
                        {
                            label: '',
                            name: 'hospitals',
                            type: "group",
                            value: '',
                            required: false,
                            multiple: true,
                            'fields': [
                                {
                                    'label': '',
                                    'name': 'hospitals_1',
                                    'fields': [
                                        {
                                            label: 'Institution',
                                            name: 'institution',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'City',
                                            name: 'city',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                    ]
                                },
                                {
                                    'label': '',
                                    'name': 'hospitals_2',
                                    'fields': [
                                        {
                                            label: 'Institution',
                                            name: 'institution',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'City',
                                            name: 'city',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                    ]
                                },
                            ]
                        },
                    ]

                },
                {
                    "name": "boards",
                    "displayName": "Board Certifications (if applicable)",
                    "required": false,

                    "fields": [
                        //allow multiple
                        {
                            label: '',
                            name: 'boards',
                            type: "group",
                            value: '',
                            required: false,
                            multiple: true,
                            'fields': [
                                {
                                    'label': '',
                                    'name': 'boards_1',
                                    'fields': [
                                        {
                                            label: 'Board Name',
                                            name: 'board_name',
                                            value: '',
                                            required: false,
                                            type: 'select',
                                            options: [
                                                'American Board of Surgery - General Surgery',
                                                'American Board of Surgery - Vascular Surgery',
                                                'American Board of Thoracic Surgery'
                                            ],
                                        },
                                        {
                                            label: 'Certified In',
                                            name: 'certification',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Date Certified',
                                            name: 'date',
                                            value: '',
                                            required: false,
                                            type: 'date'
                                        },
                                    ]
                                },
                                {
                                    'label': '',
                                    'name': 'boards_2',
                                    'fields': [
                                        {
                                            label: 'Board Name',
                                            name: 'board_name',
                                            value: '',
                                            required: false,
                                            type: 'select',
                                            options: [
                                                'American Board of Surgery - General Surgery',
                                                'American Board of Surgery - Vascular Surgery',
                                                'American Board of Thoracic Surgery'
                                            ],
                                        },
                                        {
                                            label: 'Certified In',
                                            name: 'certification',
                                            value: '',
                                            required: false,
                                            type: 'text'
                                        },
                                        {
                                            label: 'Date Certified',
                                            name: 'date',
                                            value: '',
                                            required: false,
                                            type: 'date'
                                        },
                                    ]
                                },
                            ]
                        },
                    ]

                },
                {
                    "name": "flLicensingBoard",
                    "displayName": "Florida Licensing Board",
                    "required": false,
                    "fields": [
                        {
                            label: 'Licensing Board',
                            name: 'licensing_board',
                            value: '',
                            required: false,
                            type: 'text'
                        },
                        {
                            label: 'Date Issued',
                            name: 'date_issued',
                            value: '',
                            required: false,
                            type: 'date'
                        },
                    ]
                },
                {
                    "name": "social_media",
                    "displayName": "Social Media",
                    "required": false,
                    "fields": [
                        {
                            label: 'Facebook Profile',
                            name: 'facebook',
                            value: '',
                            required: false,
                            type: 'text'
                        },
                        {
                            label: 'Twitter Handle',
                            name: 'twitter',
                            value: '',
                            required: false,
                            type: 'text'
                        },
                        {
                            label: 'Instagram Handle',
                            name: 'instagram',
                            value: '',
                            required: false,
                            type: 'text'
                        },
                        {
                            label: 'LinkedIn Profile',
                            name: 'linkedin',
                            value: '',
                            required: false,
                            type: 'text'
                        },
                    ]
                },

            ],
            attachments: [
                {
                    "name": "procedures_worksheet",
                    "label": "Completed Worksheet of major vascular reconstructive procedures performed in past 12 months. (If applicable)",
                    "file": "",
                    "link": "https://fvs.org/wp-content/uploads/2025/02/procedures_worksheet_fvs_app-1.pdf",
                },
                {
                    "name": "cv_or_resume",
                    "label": "CV/Resume (CV should include Education/Practices, Professional & Hospital Affiliations, Board Certifications, if applicable.)",
                    "file": ""
                },
                {
                    "name": "recommendation_letter_1",
                    "label": "Letter of Recommendation or Sponsoring Physician Contact Information (1)",
                    "file": ""
                },
                {
                    "name": "recommendation_letter_2",
                    "label": "Program Director or Letter of Recommendation from Sponsoring Physician Contact Information (1)",
                    "file": ""
                },
                {
                    "name": "residency_or_fellowship_certificate",
                    "label": "Copy of Residency/Fellowship Certificate",
                    "file": ""
                },
                {
                    "name": "board_certification_proof_1",
                    "label": "Proof of Board Certification (1)",
                    "file": ""
                },
                {
                    "name": "board_certification_proof_2",
                    "label": "Proof of Board Certification (2)",
                    "file": ""
                },
                {
                    "name": "membership_profile_photo",
                    "label": "Submit photo as JPEG file to be used in membership directory",
                    "file": ""
                },
                {
                    "name": "florida_license",
                    "label": "Copy of Florida License",
                    "file": ""
                },
                {
                    "name": "society_membership_proof",
                    "label": "Proof of previous membership in the Society",
                    "file": ""
                },

            ],
            app: {
                membershipType: '',
                amount:
                    0,
                year:
                    2024,
                requiredFieldSets:
                    [],
                membershipTypes:
                    [

                    ]
            },
        },
        payment: {
            cc: {
                number: '',
                firstName:
                    '',
                lastName:
                    '',
                expiry:
                    '',
                cvv:
                    '',
                type:
                    ''
            }
            ,
            response: {
                code: '',
                text:
                    '',
                authnetID:
                    '',
                paymentID:
                    '',
                errorMsg:
                    '',
                master: '',
                receiptTo: '',
                subscription: ''
            },
            promoCode: {
                PROMOID: '',
                code: '',
                description: '',
                factor: '',
            },
            autopay: {
                addAutopay: false,
                date: '-01-02',
            }
        },
/*        autopay_dates:[
            { "value": "-05-15", "text": "May 15"   },
            { "value": "-06-15", "text": "June 15" },
            { "value": "-07-15", "text": "July 15" },
        ],*/
        appStage: {
            currentProgress: 'lookup',
            sendingAttachments: false
        }
    },
    getters: {
        getState(state) {
            return state;
        }
        ,
    },
    mutations: {
        setupForm: function (state) {

            let appType = state.member.app.membershipType.text;
            let required = [];
            let standardRequired = [
                'personal',
                'contacts',
                'addresses',
                // 'education',
                // 'practices',
                // 'hospitals',
                // 'societies',
                // 'boards',
                'social_media'
            ];
            let standardRequired2 = [
                'personal',
                'contacts',
                'addresses',
                // 'education',
                // 'practices',
                // 'hospitals',
                // 'societies',
                // 'boards',

            ];
            let attachments = [];
            let standardAttachments0 = [
                'cv_or_resume',
                'recommendation_letter_1',
            ];
            let standardAttachments1 = [
                'cv_or_resume',
                'procedures_worksheet',
                'recommendation_letter_1',
            ];
            let standardAttachments2 = [
                'cv_or_resume',
                'procedures_worksheet',
                'recommendation_letter_2'
            ];
            let standardAttachments3 = [
                'cv_or_resume',
                'recommendation_letter_2'
            ];
            switch (appType) {
                case 'Active':
                    required = standardRequired;
                    attachments = standardAttachments1;
                    break;
                case 'Physician (Non-Surgeon)':
                    required = standardRequired2;
                    attachments = standardAttachments0;
                    break;
                case 'Resident/Fellow':
                    required = standardRequired2;
                    attachments = standardAttachments3;
                    state.payment.autopay.addAutopay = false;
                    break;

                case 'Fellow':
                    required = standardRequired2;
                    attachments = standardAttachments2;
                    state.payment.autopay.addAutopay = false;
                    break;

                case 'Associate':
                    required = standardRequired2;
                    attachments = standardAttachments0;
                    break;

                case 'Corresponding':
                    required = standardRequired2;
                    /*this used to use standardattachments2
                    it was changed to standardAttachments1 at Shana Harvey's request, 2024-8-21*/
                    attachments = standardAttachments1;
                    break;

                case 'Medical Student':
                    required = standardRequired2;
                    attachments = standardAttachments3;
                    state.payment.autopay.addAutopay = false;
                    break;

            }

            state.member.app.requiredFieldSets = required;
            state.member.app.requiredAttachments = attachments;

            state.member.fieldSets = state.member.fieldSets.filter((fieldSet) => {
                if (state.member.app.requiredFieldSets.includes(fieldSet.name)) {
                    return fieldSet;
                }
            });

            state.member.attachments = state.member.attachments.filter((attachemtSet) => {
                if (state.member.app.requiredAttachments.includes(attachemtSet.name)) {
                    return attachemtSet;
                }
            });

            state.appStage.currentProgress = 'app'


        },
        applicationResponse: function (state, payload) {

            state.payment.response.code = payload.formatResponse.code;
            state.payment.response.text = payload.formatResponse.text;
            state.payment.response.authnetID = payload.formatResponse.authnetID;
            state.payment.response.paymentID = payload.formatResponse.paymentID;
            state.payment.response.errorMsg = payload.formatResponse.errorMsg;

            state.payment.response.master = payload.master;
            state.payment.response.receiptTo = payload.receiptEmail;

            state.payment.response.subscription = payload.subscription;

            if (parseInt(payload.formatResponse.code) === 1 || payload.formatResponse.text === "ZERO TOTAL") {
                state.appStage.currentProgress = 'success';
            }

        },
        addNewMultiple(state, fieldSetName) {
            state.member.fieldSets.map((fieldSet) => {
                if (fieldSet.name === fieldSetName) {
                    let template = fieldSet.fields[0].fields[0];
                    fieldSet.fields[0].fields.push(template);
                }
            });


        },
        addAppRates(state, appRates) {
            let newAppRates = Object.keys(appRates).map(key => {
                return appRates[key];
            });
            appRates = newAppRates.filter((type) => {
                type.dialog_open = false;
                return type;
            });
            state.member.app.membershipTypes = appRates;
        },
        updatePromoCode(state, promoCode){
            //update state with found and verified promocode discount
            state.payment.promoCode = promoCode;
            console.log('promocode factor is ' + state.payment.promoCode.factor);
        }
    },
    actions: {
        getAppRates: function (context) {
            //send lookup member request

            axios.get('https://db.fvs.org/api/join/rates').then(function (response) {
                console.log(response.data.data);
                context.commit('addAppRates', response.data.data);
            });


        },
        saveApplication: function (context) {

            let apiConfig = {
                data: {
                    applicationState: context.state,
                },
                method: 'post',
                url: 'https://db.fvs.org/api/join/store',
                headers: {'Content-Type': 'application/json'},
            };

            axios(apiConfig).then(
                response => {
                    console.log(response);
                    let formatResponse = {
                        code: '',
                        text: '',
                        authnetID: '',
                        paymentID: '',
                        errorMsg: ''
                    };

                    if (response.data.status === 'OK') {

                        if (response.data.transaction.authnet_description === 'ZERO TOTAL') {
                            formatResponse.code = '';
                            formatResponse.text = response.data.transaction.authnet_description;
                            formatResponse.authnetID = '';
                            formatResponse.paymentID = response.data.transaction.PAYMENTID;
                        } else {
                            formatResponse.code = response.data.transaction.authnet_result;
                            formatResponse.text = response.data.transaction.authnet_description;
                            formatResponse.authnetID = response.data.transaction.authnet_trans_id;
                            formatResponse.paymentID = response.data.transaction.PAYMENTID;
                        }

                    } else {
                        formatResponse.errorMsg = response.data.data.message;
                    }

                    let s = response.data.subscription;

                    let subscribe = {
                        subscription_id: '',
                        discount: 0,
                        subscription_message: '',
                    }
                    if(s.subscription_id){
                        subscribe = {
                            subscription_id: s.subscription_id,
                            discount: s.discount
                        }
                    } else {
                        subscribe.subscription_message = s.message
                        //alert ('message: ' + s.message);
                    }
                    let payload = {
                        formatResponse: formatResponse,
                        master: response.data.master,
                        subscription: subscribe,
                        receiptEmail: response.data.receiptTo,
                    };

                    context.commit('applicationResponse', payload);

                }
            ).then(() => {
                context.dispatch('sendReceipt');
            });


        },
        uploadAttachments(context) {

            context.state.appStage.sendingAttachments = true;

            let formData = new FormData();
            formData.append('ID', context.state.payment.response.master.ID);

            let atchmnts = context.state.member.attachments;

            for (let i = 0; i < atchmnts.length; i++) {
                formData.append(atchmnts[i].name, atchmnts[i].file);
                // console.log(atchmnts[i].name + " " + atchmnts[i].file);
            }


            axios.post('https://db.fvs.org/api/join/store/attachments',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function () {
                context.state.appStage.sendingAttachments = false;
            })
                .catch(function () {
                    alert('There was an issue uploading your attachments!');
                });
        },
        sendReceipt: function (context) {
            //send lookup member request


            axios('https://db.fvs.org/api/transcation/sendreceipt/' + context.state.payment.response.paymentID + '/0/' + context.state.payment.response.receiptTo)
                .then(function (response) {
                    if (response.data.status === 'ERROR') {
                        alert(response.data.data.message);

                    }
                    context.dispatch('uploadAttachments');
                });

            axios('https://db.fvs.org/api/transcation/sendreceipt/' + context.state.payment.response.paymentID + '/0/membership@fvs.org');
            axios('https://db.fvs.org/api/transcation/sendreceipt/' + context.state.payment.response.paymentID + '/1/accounting@fvs.org');
            axios('https://db.fvs.org/api/transcation/sendreceipt/' + context.state.payment.response.paymentID + '/0/webmaster@fvs.org');


        },
        lookupPromoCode: function (context, promoText) {
            let apiConfig = {
                data: {
                    promoText: promoText,
                },
                method: 'get',
                url: 'https://db.fvs.org/api/promocode/find/' + promoText,
            };

            axios(apiConfig).then(
                response => {

                    let p = response.data.promoCode[0];

                    if(p){
                        let promoCode = {
                            PROMOID: p.PROMOID,
                            code: p.promo_code,
                            description: p.narrative,
                            factor: p.factor,
                        }

                        context.commit('updatePromoCode', promoCode);
                    }
                }
            );
        }
    }
})